var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img"},[_c('el-image',{style:({width: _vm.width,height: _vm.height}),attrs:{"preview-src-list":_vm.previewList,"src":_vm.url,"crossorigin":"anonymous","fit":_vm.fit},on:{"load":_vm.load}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }